import React, {useState, useEffect, useRef, memo} from 'react'
import {Redirect} from 'react-router-dom'
import {ServerConfig} from 'config'
import axios from 'axios'
import {useSelector} from 'react-redux'

import loading_gif from '../../assets/img/loading.gif'

import Select from 'react-select';
import SortableTbl from "react-sort-search-table";
import DatePicker from "react-datepicker";

import "react-datepicker/dist/react-datepicker.css";

import {makeStyles} from '@material-ui/core/styles'
import {Typography, Grid, Checkbox, Button} from '@material-ui/core'

import _ from 'lodash'
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import AccessTimeIcon from "@material-ui/icons/AccessTimeOutlined";

const useStyles = makeStyles((theme) => ({
	datePickerPopper: {
        zIndex: '999 !important',
    },
}))


const Logs = () => {
  const token = useSelector(state => state.auth.access_token)

  const tenant = useSelector(state => state.auth.tenant)
  console.log(tenant);
  console.log(tenant.state);

  const [availableMachines, setAvailableMachines] = useState([])
  const [selectedMachine_ids, setSelectedMachine_ids] = useState([])
  const [logs, setLogs] = useState([])
  const [logsCertIds, setLogsCertIds] = useState([])
  const [tenantSites, setTenantSites] = useState([])

  let default_start_date = new Date();
  default_start_date.setDate(default_start_date.getDate() - 2);
  const [startDate, setStartDate] = useState(default_start_date);

  const [endDate, setEndDate] = useState(new Date());

  const [selectedMaterials, setSelectedMaterials] = useState(['alu', 'pete', 'hdpe', 'glass']);

  let default_options;
  if (tenant.state == "CA") {
    default_options = ["sizes", "weights"];
  } else if (tenant.state == "NY") {
    default_options = [];
  } else {
    default_options = ["sizes", "weights"];
  }

  const [selectedOptions, setSelectedOptions] = useState(default_options);
  const [logsReceived, setLogsReceived] = useState(new Date())

  const [cols, setCols] = useState([]);
  const [heads, setHeads] = useState([]);

  const [isLoading, setIsLoading] = useState(false);

  const logsAbortControllerRef = useRef(null)

  const classes = useStyles()

  async function fetchMachineList(token) {
    const config = {headers: {'Content-Type': 'application/json'}}

    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }

    const results = await axios.get(`${ServerConfig.SERVER_URL}/tenant/machines`, config);
    const options = [];

    for (let idx in results.data) {
      options.push({value: results.data[idx].id, label: results.data[idx].name});
    }
    setAvailableMachines(options)
    setSelectedMachine_ids(options)
  }


  async function request_download(token) {
    setIsLoading(true);

    const config = {
      responseType: 'blob',
      headers: {
        'Content-Type': 'application/json',
        'Accept': "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
      },
    }

    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }

    const machine_ids = selectedMachine_ids.map(m => m.value);

    const body = JSON.stringify({
      machine_ids: machine_ids,
      start_ts_utc: startDate.getTime(),
      end_ts_utc: endDate.getTime(),
      materials: selectedMaterials,
      options: selectedOptions
    })

    var filename;

    axios.post(`${ServerConfig.SERVER_URL}/tenant/logs_excel`, body, config)
      .then(response => {
        const disposition = response.headers['content-disposition'];
        filename = disposition.split(/;(.+)/)[1].split(/=(.+)/)[1];
        if (filename.toLowerCase().startsWith("utf-8''")) {
          filename = decodeURIComponent(filename.replace("utf-8''", ''));
        } else {
          filename = filename.replace(/['"]/g, '');
        }
        return response.data;
      })
      .then(response_data => {
        let blob = new Blob([response_data], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'})
        var url = window.URL.createObjectURL(blob);
        var a = document.createElement('a');
        a.href = url;
        a.download = filename;
        document.body.appendChild(a);
        a.click();
        a.remove();
      })
      .catch(error => {
        console.error(error);
      })
      .finally(() => {
        setIsLoading(false);
      });
  }


  async function request_download_pdf(token) {
    setIsLoading(true);

    const config = {
      responseType: 'blob',
      headers: {
        'Content-Type': 'application/json',
        'Accept': "application/pdf"
      },
    }

    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }

    const machine_ids = selectedMachine_ids.map(m => m.value);

    const body = JSON.stringify({
      machine_ids: machine_ids,
      start_ts_utc: startDate.getTime(),
      end_ts_utc: endDate.getTime()
    })

    var filename;

    axios.post(`${ServerConfig.SERVER_URL}/tenant/logs_pdf`, body, config)
      .then(response => {
        const disposition = response.headers['content-disposition'];
        filename = disposition.split(/;(.+)/)[1].split(/=(.+)/)[1];
        if (filename.toLowerCase().startsWith("utf-8''")) {
          filename = decodeURIComponent(filename.replace("utf-8''", ''));
        } else {
          filename = filename.replace(/['"]/g, '');
        }
        return response.data;
      })
      .then(response_data => {
        let blob = new Blob([response_data], {type: 'application/pdf'})
        var url = window.URL.createObjectURL(blob);
        var a = document.createElement('a');
        a.href = url;
        a.download = filename;
        document.body.appendChild(a);
        a.click();
        a.remove();
      })
      .catch(error => {
        console.error(error);
      })
      .finally(() => {
        setIsLoading(false);
      });
  }


  async function fetchMachineTransactions(token) {
    console.log("Updating machine tasks")

    // cancel any request from this component that's still in flight
    if (logsAbortControllerRef.current) {
      logsAbortControllerRef.current.abort();
    }
    const controller = new AbortController();
    logsAbortControllerRef.current = controller;

    setIsLoading(true);

    const config = {headers: {'Content-Type': 'application/json'}, signal: controller.signal}

    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }

    const machine_ids = [];
    for (let idx in selectedMachine_ids) {
      machine_ids.push(selectedMachine_ids[idx].value);
    }

    let results;
    try {
      results = await axios.post(`${ServerConfig.SERVER_URL}/tenant/logs`, {
        machine_ids: machine_ids,
        start_ts_utc: startDate.getTime(),
        end_ts_utc: endDate.getTime()
      }, config)
    } catch (err) {
      if (axios.isCancel(err) || err.code === 'ERR_CANCELED') {
        return; // superseded by a newer request, ignore
      }
      console.error(err);
      setIsLoading(false);
      return;
    }

    for (let idx in results.data.tasks) {
      console.log("Processing idx: " + idx);

      let dollarvalue = "$" + (results.data.tasks[idx].redemption_amount_cents / 100.0).toFixed(2);

      console.log("New dollarvalue: " + dollarvalue);

      let has_scrap = '';
      if (results.data.tasks[idx]['scrap'] !== undefined) {
        for (let scrap_material in results.data.tasks[idx]['scrap']) {
          for (let scrap_idx in results.data.tasks[idx]['scrap'][scrap_material]) {
            has_scrap += scrap_material + " (" + results.data.tasks[idx]['scrap'][scrap_material][scrap_idx]['category'] + "): ";

            // count-based
            if (results.data.tasks[idx]['scrap'][scrap_material][scrap_idx]['count'] !== undefined) {
              has_scrap += results.data.tasks[idx]['scrap'][scrap_material][scrap_idx]['count'] + "x" +
                results.data.tasks[idx]['scrap'][scrap_material][scrap_idx]['size_oz'] + "oz\n";
            }

            // weight-based
            if (results.data.tasks[idx]['scrap'][scrap_material][scrap_idx]['weight_lbs'] !== undefined) {
              has_scrap += results.data.tasks[idx]['scrap'][scrap_material][scrap_idx]['weight_lbs'] + "lbs\n";
            }
          }
        }
      }

      let datetime;
      if (window.innerWidth >= 1080) {
        datetime = new Intl.DateTimeFormat('en-US',
          {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit',
          }
        ).format(new Date(results.data.tasks[idx].end_ts));
      } else {
        datetime = new Intl.DateTimeFormat('en-US',
          {
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
          }
        ).format(new Date(results.data.tasks[idx].end_ts));
      }
      _.extend(results.data.tasks[idx], {'datetime': datetime, 'redemption_amount_dollar': dollarvalue, 'scrap': has_scrap});
    }

    setLogs(results.data.tasks);
    setLogsCertIds(results.data.cert_ids)
    setTenantSites(results.data.tenant_sites)
    setLogsReceived(new Date());
    setIsLoading(false);
  }


  useEffect(() => {
    fetchMachineList(token)
  }, [token])

  let materials_and_abbreviations = [
    ['aluminum', 'aluminum', 'Alu'],
    ['bi-metal', 'bi-metal', 'Bi-M'],
    ['pete', 'pete', 'PETE'],
    ['hdpe', 'hdpe', 'HDPE'],
    ['ldpe', 'ldpe', 'LDPE'],
    ['pp', 'pp', 'PP'],
    ['ps', 'ps', 'PS'],
    ['pvc', 'pvc', 'PVC'],
    ['other', 'other', 'OTHER'],
    ['glass', 'glass', 'Glass'],
    ['bag-in-box', 'bag-in-box', 'BiB'],
    ['paperboard-carton', 'paperboard-carton', 'PC'],
    ['multilayer-pouch', 'multilayer-pouch', 'MP'],
  ]


  useEffect(() => {
    console.log("Selected Materials: " + selectedMaterials);
    let new_cols = ["datetime"];
    let new_heads = ["Date"]

    new_cols.push("customer_name");
    new_heads.push("Customer");

    if (window.innerWidth >= 1080) {  // Not responsive yet
      new_cols.push("tenant_employee_name");
      new_heads.push("Employee");

      for (let i = 0; i < materials_and_abbreviations.length; i++) {
        if (selectedMaterials.includes(materials_and_abbreviations[i][0])) {
          if (selectedOptions.includes('sizes')) {
            new_cols.push("count_" + materials_and_abbreviations[i][1] + "_lt_24oz");
            new_cols.push("count_" + materials_and_abbreviations[i][1] + "_geq_24oz");

            new_heads.push(materials_and_abbreviations[i][2] + " (S)")
            new_heads.push(materials_and_abbreviations[i][2] + " (L)")
          } else {
            new_cols.push("count_" + materials_and_abbreviations[i][1]);
            new_heads.push(materials_and_abbreviations[i][2]);
          }

          if (selectedOptions.includes('weights')) {
            new_cols.push("weight_" + materials_and_abbreviations[i][1] + "_lbs");
            new_heads.push(materials_and_abbreviations[i][2] + " lbs");
          }
        }
      }

      if (selectedMaterials.includes("scrap")) {
        new_cols.push("scrap");
        new_heads.push("Has Scrap");
      }
    } // do not show if screen too small

    new_cols.push("redemption_amount_dollar");
    new_heads.push("Paid");

    setCols(new_cols);
    setHeads(new_heads);
  }, [selectedMaterials, selectedOptions])

  useEffect(() => {
    const debounceTimer = setTimeout(() => {
      fetchMachineTransactions(token);
    }, 300);

    return () => {
      clearTimeout(debounceTimer);
      if (logsAbortControllerRef.current) {
        logsAbortControllerRef.current.abort();
      }
    };

  }, [selectedMachine_ids, startDate, endDate, token])

  if (!token) {
    return <Redirect to="/login"/>
  }

  const handleChange = (event) => {
    if (event.target.checked) {
      if (event.target.name == 'all_materials') {
        let newSelectedMaterials = []
        for (var i in materials_and_abbreviations) {
          console.log("Selecting material " + materials_and_abbreviations[i][0]);
          newSelectedMaterials.push(materials_and_abbreviations[i][0]);
          document.getElementsByName(materials_and_abbreviations[i][0])[0].checked = true;
        }
        setSelectedMaterials(newSelectedMaterials);
      } else {
        if (!selectedMaterials.includes(event.target.value)) {
          setSelectedMaterials([...selectedMaterials, event.target.name]);
        }
      }
    } else {
      if (event.target.name == 'all_materials') {
        let newSelectedMaterials = []
        for (var i in materials_and_abbreviations) {
          console.log("De-Selecting material " + materials_and_abbreviations[i][0]);
          document.getElementsByName(materials_and_abbreviations[i][0])[0].checked = false;
        }
        setSelectedMaterials(newSelectedMaterials);
      } else {
        const newSelectedMaterials = selectedMaterials.filter((entry) => entry !== event.target.name);
        setSelectedMaterials(newSelectedMaterials);
      }
    }
  };

  const handleChangeFields = (event) => {
    if (event.target.checked) {
      if (!selectedOptions.includes(event.target.value)) {
        setSelectedOptions([...selectedOptions, event.target.name]);
      }
    } else {
      const newSelectedMaterials = selectedOptions.filter((entry) => entry !== event.target.name);
      setSelectedOptions(newSelectedMaterials);
    }
  }

  return (
    <>
      <Grid container spacing={3}>
        <Grid xs={12} sm={3} style={{'margin-bottom': '20px', 'padding-right': '20px'}}>
          <Typography variant="h2">
            Devices:
          </Typography>

          {availableMachines.length > 0 &&
            <Select
              isMulti
              /*className="form-select"*/
              name="machine"
              id="machine"
              onChange={(event) => {
                setSelectedMachine_ids(event)
              }}  // [{value:'', label:''}, ...]
              options={availableMachines}
              defaultValue={availableMachines}
              classNamePrefix="react-select"
            />
          }
        </Grid>

        <Grid xs={12} sm={2} style={{'marginBottom': '20px'}}>
          <Typography variant="h2">
            Start-Date (incl.):
          </Typography>
          <DatePicker selected={startDate} onChange={(date) => {
            setStartDate(date)
          }}
                      showTimeSelect
                      dateFormat="MMMM d, yyyy h:mm aa"
                      className="form-select"
                      popperClassName={classes.datePickerPopper}
                      />
        </Grid>

        <Grid xs={12} sm={2} style={{'marginBottom': '20px'}}>
          <Typography variant="h2">
            End-Date (incl.):
          </Typography>
          <DatePicker selected={endDate} onChange={(date) => {
            setEndDate(date)
          }}
                      showTimeSelect
                      dateFormat="MMMM d, yyyy h:mm aa"
                      className="form-select"
                      popperClassName={classes.datePickerPopper}
                      />
        </Grid>

        <Grid xs={12} sm={1}></Grid>

        {window.innerWidth >= 1080 &&  // Not responsive yet
          <>
            <Grid xs={4} sm={1} style={{'marginBottom': '20px'}}>
              <Typography variant="h2"><Checkbox defaultChecked={(selectedOptions.includes('sizes'))}
                                                 onChange={handleChangeFields} name="sizes"/> Sizes</Typography>
            </Grid>

            <Grid xs={4} sm={1} style={{'marginBottom': '20px'}}>
              <Typography variant="h2"><Checkbox defaultChecked={(selectedOptions.includes('weights'))}
                                                 onChange={handleChangeFields} name="weights"/> Lbs</Typography>
            </Grid>

            <Grid xs={4} sm={1} style={{'marginBottom': '20px'}}>
              <Typography variant="h2"><Checkbox onChange={handleChange} name="all_materials"/>All</Typography>
            </Grid>

            <Grid xs={12} style={{'textAlign': 'center'}}>
              <Typography variant="h2">
                Materials:
              </Typography>
            </Grid>

            <Grid xs={2} sm={1}><Typography variant="h2"><Checkbox checked={selectedMaterials.includes("aluminum")}
                                                                   onChange={handleChange} name="aluminum"/> Alu</Typography></Grid>
            <Grid xs={2} sm={1}><Typography variant="h2"><Checkbox checked={selectedMaterials.includes("bi-metal")}
                                                                   onChange={handleChange}
                                                                   name="bi-metal"/> Bi-Metal</Typography></Grid>
            <Grid xs={2} sm={1}><Typography variant="h2"><Checkbox checked={selectedMaterials.includes("pete")}
                                                                   onChange={handleChange}
                                                                   name="pete"/> PETE</Typography></Grid>
            <Grid xs={2} sm={1}><Typography variant="h2"><Checkbox checked={selectedMaterials.includes("hdpe")}
                                                                   onChange={handleChange}
                                                                   name="hdpe"/> HDPE</Typography></Grid>
            <Grid xs={2} sm={1}><Typography variant="h2"><Checkbox checked={selectedMaterials.includes("ldpe")}
                                                                   onChange={handleChange}
                                                                   name="ldpe"/> LDPE</Typography></Grid>
            <Grid xs={2} sm={1}><Typography variant="h2"><Checkbox checked={selectedMaterials.includes("pp")}
                                                                   onChange={handleChange}
                                                                   name="pp"/> PP</Typography></Grid>
            <Grid xs={2} sm={1}><Typography variant="h2"><Checkbox checked={selectedMaterials.includes("ps")}
                                                                   onChange={handleChange}
                                                                   name="ps"/> PS</Typography></Grid>
            <Grid xs={2} sm={1}><Typography variant="h2"><Checkbox checked={selectedMaterials.includes("pvc")}
                                                                   onChange={handleChange} name="pvc"/> PVC</Typography></Grid>
            <Grid xs={2} sm={1}><Typography variant="h2"><Checkbox checked={selectedMaterials.includes("other")}
                                                                   onChange={handleChange}
                                                                   name="other"/> Other</Typography></Grid>
            <Grid xs={2} sm={1}><Typography variant="h2"><Checkbox checked={selectedMaterials.includes("glass")}
                                                                   onChange={handleChange}
                                                                   name="glass"/> Gl</Typography></Grid>
            <Grid xs={2} sm={1}><Typography variant="h2"><Checkbox checked={selectedMaterials.includes("bag-in-box")}
                                                                   onChange={handleChange} name="bag-in-box"/> BiB</Typography></Grid>
            <Grid xs={2} sm={1}><Typography variant="h2"><Checkbox checked={selectedMaterials.includes("paperboard-carton")}
                                                                   onChange={handleChange}
                                                                   name="paperboard-carton"/> PC</Typography></Grid>
            <Grid xs={2} sm={1}><Typography variant="h2"><Checkbox checked={selectedMaterials.includes("multilayer-pouch")}
                                                                   onChange={handleChange}
                                                                   name="multilayer-pouch"/> MP</Typography></Grid>
            <Grid xs={2} sm={1}><Typography variant="h2"><Checkbox checked={selectedMaterials.includes("scrap")}
                                                                   onChange={handleChange}
                                                                   name="scrap"/> Scrap</Typography></Grid>
          </>
        }

        <Grid xs={12} style={{'textAlign': 'center', 'marginTop': '20px', 'whiteSpace': 'pre', 'overflowX':'auto'}}>
          {!isLoading &&
            <>
              <Grid xs={12} style={{'textAlign': 'left', 'marginTop': '20px'}}>
                <Button onClick={() => request_download(token)}>Download Excel</Button>
                <Button onClick={() => request_download_pdf(token)}>Download PDF</Button>
              </Grid>

              <Grid item xs={12} style={{'padding': 0, marginTop: '20px'}}>
                <Card style={{'margin': 0}}>
                  <CardContent style={{'paddingBottom': 0, 'paddingTop': 0, 'textAlign': 'left'}}>
                    <AccessTimeIcon style={{'color': 'rgb(0,79,113)'}}/> Data Received: {logsReceived.toString()}<br/>
                  </CardContent>
                </Card>
              </Grid>

              <Grid item xs={12} style={{'padding': 0, marginTop: '20px'}}>
                <Card style={{'margin': 0}}>
                  <CardContent style={{'paddingBottom': 0, 'paddingTop': 0, 'textAlign': 'left'}}>

                    Certification #: {_.map(logsCertIds, cert_id => {
                      return <span>{cert_id} </span>
                    })
                    }<br/>
                    Recycler Center Name: {_.map(tenantSites, tenant_site => {
                      return <span>{tenant_site.name} </span>
                    })
                  }
                  </CardContent>
                </Card>
              </Grid>

              <SortableTbl
                paging={false}
                defaultCSS={false}
                tblData={logs}
                tHead={heads}
                dKey={cols}
                search={false}
              />
            </>
          }
          {isLoading &&
            <img src={loading_gif} style={{'width': '150px'}}/>
          }
        </Grid>
      </Grid>
    </>
  )
}

export default Logs


